import * as Yup from 'yup';

export const scheduleEmailFormSchema = Yup.object().shape({
  scheduleInterval: Yup.string().required('Interval is required'),
  scheduleDay: Yup.string().when('scheduleInterval', {
    is: (val: any) => val && val == 'weekly', // Checks if scheduleInterval is available
    then: (schema) => schema.required('Day is required'), // Validate scheduleDay only if scheduleInterval exists
    otherwise: (schema) => schema.notRequired(), // Otherwise, scheduleDay is not required
  }),
  scheduleDate: Yup.string().when('scheduleInterval', {
    is: (val: any) => val && (val == 'monthly' || val == 'annually'), // Checks if scheduleInterval is available
    then: (schema) => schema.required('Date is required'), // Validate scheduleDay only if scheduleInterval exists
    otherwise: (schema) => schema.notRequired(), // Otherwise, scheduleDay is not required
  }),
  scheduleTime: Yup.string().required('Time is required'),
});
